'use strict'

define ['./experian.css'], () ->
  (RENTAPPLICATION_API_URL, RentappService, Experian) ->
    restrict: "E"
    template: require("./experian.jade")
    scope:
      reportSourceProfiles: "="
    link: (scope, element, attrs) ->
      scope.beginExperianVerification = () ->
        if scope.reportSourceProfiles and scope.reportSourceProfiles.length
          exp_rsp = scope.reportSourceProfiles[0]
          Experian.beginExperianVerification()




// WEBPACK FOOTER //
// ./directives/rspSignupPrompts/report_source_profiles/experian/experian.coffee